import React, { createContext, useState, useContext, useMemo } from "react";
import { BUSINESS_OBJECT } from "../../common_nextgen/utils/Constants";

export const AuthHeaderStorageKey = "ppfAuthHeaders";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get("sessionId");
  const tenantId = urlParams.get("tenantId");
  const authType = urlParams.get("authType");
  const [AuthHeaders, setAuthHeaders] = useState({
    "session-id": sessionId,
    "tenant-id": tenantId,
    "auth-type": authType,
    "business-object": BUSINESS_OBJECT.ACCUMS,
  });
  sessionStorage.setItem(AuthHeaderStorageKey, JSON.stringify(AuthHeaders));
  return (
    <AuthContext.Provider value={{ AuthHeaders, setAuthHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
